import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-27e1d3fa")

_pushScopeId("data-v-27e1d3fa")
const _hoisted_1 = { class: "ques q-a-ques" }
const _hoisted_2 = { class: "q-cont" }
const _hoisted_3 = {
  key: 0,
  class: "answer-area"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("dt", null, "答案：", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("dt", null, "得分：", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("dt", null, "解析：", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.quesData.totalSort ? _ctx.quesData.totalSort + '.' : ''), 1),
      _createVNode("span", {
        innerHTML: _ctx.quesData.questionContent
      }, null, 8, ["innerHTML"]),
      _createTextVNode(_toDisplayString(_ctx.quesData.score ? '（' + _ctx.quesData.score + '分）' : ''), 1)
    ]),
    _createVNode(_component_el_input, {
      class: "q-a-textarea",
      type: "textarea",
      resize: "none",
      autosize: { minRows: 5 },
      placeholder: "请在这里输入答案",
      modelValue: _ctx.content,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.content = $event)),
      onInput: _ctx.handleContentInput,
      readonly: _ctx.showAnswer
    }, null, 8, ["modelValue", "onInput", "readonly"]),
    (_ctx.showAnswer)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("dl", null, [
            _hoisted_4,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.rightAnswer), 1)
          ]),
          _createVNode("dl", null, [
            _hoisted_5,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.studentScore), 1)
          ]),
          _createVNode("dl", null, [
            _hoisted_6,
            _createVNode("dd", null, _toDisplayString(_ctx.quesData.analysis ? _ctx.quesData.analysis : '略'), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})